import React, { createContext, useContext } from 'react';

import { useId } from 'utils/hooks';

const ModalContext = createContext({
  isDisabled: false,
  isProcessing: false,
  footerId: 'modal-footer-id',
  onClose: () => {}
});

export const useModal = () => useContext(ModalContext);

export function ModalProvider({
  isProcessing = false,
  isDisabled = false,
  onClose = () => {},
  children = null
}) {
  const footerId = useId('modal-footer');

  return (
    <ModalContext.Provider
      value={{
        onClose,
        footerId,
        isDisabled,
        isProcessing
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}
